// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingWidgetContent-moduleDocFlowSendingWidgetContent__dZXYj";
var _2 = "DocFlowSendingWidgetContent-moduleheader__xwAc5";
export { _1 as "DocFlowSendingWidgetContent", _2 as "header" }
